import React from 'react'

import { Button as ShadButton, ButtonProps as ShadButtonProps } from '@ps/ds/ui/button'

// remove the broader 'size' from ShadButtonProps and expose a narrower set
export interface IconButtonProps extends Omit<ShadButtonProps, 'size'> {
  size?: 'xxs' | 'xs' | 'sm' | 'md'
  variant?: 'primary' | 'secondary' | 'muted' | 'ghost'
  rounded?: boolean
  icon?: React.ReactNode
  children?: React.ReactNode
}

export const isIconButtonVariantType = (
  variant: string,
): variant is NonNullable<IconButtonProps['variant']> => {
  return ['primary', 'secondary', 'muted', 'ghost'].includes(variant)
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    { size = 'md', variant = 'primary', rounded = false, children, icon: leadingIcon, ...props },
    ref,
  ) => {
    return (
      <ShadButton
        data-type="icon-button"
        ref={ref}
        size={`icon-${size}`}
        variant={variant}
        rounded={rounded}
        leadingIcon={leadingIcon}
        {...props}>
        {children}
      </ShadButton>
    )
  },
)

IconButton.displayName = 'IconButton'
